import React, { useEffect, useState } from 'react';
import './Toast.scss';

export interface ToastProps {
  isVisible: boolean;
  icon?: React.ReactNode;
  headerMessage: string;
  headerColor?: string;
  message?: string;
  messageColor?: string;
  autoClose?: boolean;
  autoCloseTime?: number;
  showCloseButton?: boolean;
  onClose: () => void;
}

const Toast: React.FC<ToastProps> = ({
  isVisible,
  icon,
  headerMessage,
  headerColor = '#F97066',
  message,
  messageColor = '#B8C5CC',
  autoClose = false,
  autoCloseTime = 5000,
  showCloseButton = true,
  onClose,
}) => {
  const [isShowing, setIsShowing] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setIsShowing(true);

      if (autoClose && autoCloseTime > 0) {
        const timer = setTimeout(() => {
          handleClose();
        }, autoCloseTime);

        return () => clearTimeout(timer);
      }
    } else {
      setIsShowing(false);
    }

    return undefined;
  }, [isVisible, autoClose, autoCloseTime]);

  const handleClose = () => {
    setIsShowing(false);
    onClose();
  };

  if (!isShowing) return null;

  return (
    <div className='toast-container'>
      <div className='toast-content'>
        {icon && <div className='toast-icon'>{icon}</div>}

        <div className='toast-message-container'>
          <div className='toast-header' style={{ color: headerColor }}>
            {headerMessage}
          </div>

          {message && (
            <div className='toast-body' style={{ color: messageColor }}>
              {message}
            </div>
          )}
        </div>

        {showCloseButton && (
          <button analytics-id='toast-close-btn' className='toast-close-button' onClick={handleClose}>
            <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M9.5 2.5L2.5 9.5M2.5 2.5L9.5 9.5'
                stroke='#B8C5CC'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default Toast;
